import {BOOK_ADDED, BOOK_EDITED, BOOK_LOADED, BOOK_REMOVED} from "./actionTypes";

export const bookLoaded = (booksFromServer) => {
    return {
        type: BOOK_LOADED,
        payload: booksFromServer
    }
}

export const bookAdded = (bookData) => {
    return {
        type: BOOK_ADDED,
        payload: bookData
    }
}

export const bookRemoved = (bookId) => {
    return {
        type: BOOK_REMOVED,
        payload: bookId
    }
}

export const bookEdited = (bookData) => {
    return {
        type: BOOK_EDITED,
        payload: bookData
    }
}